module.exports = {
  SENSITIVE: 200,
  LOW: 300,
  MEDIUM: 800,
  GENEROUS: 1500,
  AUTOCLOSE: 3000,
};
